import { SPECIAL_USAGES_IDS } from "./hooks/useEditSubstanceFieldsConfig";

export const isStudiesTabEnabled = (substance: any) => {
    return (
        substance?.nombreComercial &&
        substance?.idsUso?.length &&
        substance?.idsModoEmpleo?.length &&
        substance?.cantidadAnual &&
        substance?.idUnidadMedida &&
        substance?.informe !== null &&
        substance?.capacitacion !== null &&
        substance?.estudiosRemplazo &&
        substance?.licenciaEspecial !== null &&
        substance?.idsMedidaPrevencion?.length &&
        substance?.idsElementoProteccion?.length
    );
};

export const isSubstanceDataComplete = (substance: any) => {
    const requiresQuantity =
        Array.isArray(substance?.idsUso) &&
        substance?.idsUso.some((id: number) => !SPECIAL_USAGES_IDS.includes(id));
    return (
        substance?.nombreComercial &&
        substance?.idsUso?.length &&
        substance?.idsModoEmpleo?.length &&
        (requiresQuantity
            ? substance?.cantidadAnual !== null &&
              substance?.cantidadAnual !== undefined &&
              substance?.idUnidadMedida
            : true) &&
        substance?.informe !== null &&
        substance?.capacitacion !== null &&
        substance?.estudiosRemplazo &&
        substance?.licenciaEspecial !== null &&
        substance?.idsMedidaPrevencion?.length &&
        substance?.idsElementoProteccion?.length &&
        substance?.estudios?.length > 0
    );
};
